import { createAction, props } from '@ngrx/store';

import {
  CopyCropFieldsToManureSpaceCompleted,
  CopyCropFieldsToManureSpaceStarted,
} from '../copy-cropfields-to-manure-space.models';

export const copyCropFieldsToManureSpaceStarted = createAction(
  '[Copy cropfields] Copy CropFields to manure space started',
  props<CopyCropFieldsToManureSpaceStarted>(),
);

export const copyCropFieldsToManureSpaceCompleted = createAction(
  '[Copy cropfields] Copy cropfields to manure space completed',
  props<CopyCropFieldsToManureSpaceCompleted>(),
);

export const completedCopyAll = createAction('[Copy cropfields] Completed copy all');

export const copyDialogDismissed = createAction('[Copy cropfields] Copy dialog dismissed');

export const dismissCopyCropFieldsStatus = createAction(
  '[Copy cropfields] Dismiss Copy cropfields status',
);
